export const getFormattedEventLabel = (label: string) => {
  return label.toLowerCase().split(' ').join('_')
}
